import { OdysseyUser } from "@utils";
import { Reference } from "@apollo/client";
import { TaskFragmentDoc, useCreateTasksMutation } from "@graphql";
import { UnsavedTasks } from "./Prompt";
import { createTaskId } from "@utils/task-id";
import { parse } from "querystring";
import { useMount } from "react-use";

type UnsavedProgressProps = {
  user: OdysseyUser;
  courseId: string;
};

export default function UnsavedProgress({
  user,
  courseId,
}: UnsavedProgressProps) {
  const [createTasks] = useCreateTasksMutation({
    onCompleted() {
      history.replaceState({}, "", location.pathname);
    },
    update(cache, { data }) {
      cache.modify({
        id: cache.identify(user),
        fields: {
          tasks: (existingTaskRefs: Reference[], { readField }) => {
            const tasks = data?.user?.tasks;

            if (!tasks?.length) {
              return existingTaskRefs;
            }

            const taskRefIds = existingTaskRefs.map((ref) =>
              readField("id", ref)
            );

            const newTasks = tasks
              .filter((task) => !taskRefIds.includes(task.id))
              .map((task) => {
                return cache.writeFragment({
                  data: task,
                  fragment: TaskFragmentDoc,
                });
              });

            return [...existingTaskRefs, ...newTasks];
          },
        },
      });
    },
  });

  useMount(() => {
    const { tasks } = parse(location.search.slice(1));

    if (typeof tasks === "string") {
      try {
        const parsed: UnsavedTasks = JSON.parse(tasks);
        createTasks({
          variables: {
            userId: user.id,
            tasks: Object.entries(parsed).map(([taskId, value]) => ({
              taskId: createTaskId({ taskId, courseId }),
              completedAt: new Date(),
              value: value === true ? null : value,
            })),
          },
        });
      } catch (error) {
        // do nothing
      }
    }
  });

  return null;
}
